import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { wizard } from 'helpers/decorators'
import { Title, Button, FormDebug } from 'components/misc'
import { Contact } from 'components/forms'
import { apiCodeLists, apiNextLevel, apiConfiguration } from 'helpers/decorators/api'
import validate from './contacts.validation'
import { CONFIGURATION_KEYS } from 'constants/enums'

@apiCodeLists(['phoneTypes'], {
  public: true
})
@apiNextLevel()
@apiConfiguration()
@wizard({
  form: 'nextLevelRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate
})
class Contacts extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    values: PropTypes.object,
    getConfigurationKeyValue: PropTypes.func.isRequired
  }


  render() {
    const { handleSubmit, codeLists, onSubmit, values } = this.props
    const isEmailFixed = get(values, 'helpers.isEmailFixed')
    const selectedCountryIcoCode = get(
      values,
      'helpers.selectedCountry.isoCode'
    )

    const showSecondaryEmail = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationEmailAddress2.id)
    const showPhoneNumber = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationPhoneNumber.id)
    const showPhoneType = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationPhoneType.id)
    const showSecondaryPhone = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationSecondaryPhone.id)
    const showSecondaryPhoneType = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationSecPhoneType.id)


    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.contact_details"
            defaultMessage="Contact Details"
          />
        </Title>

        <Contact
          showSecondaryFields
          showPhoneNumber={showPhoneNumber}
          showPhoneType={showPhoneType}
          showSecondaryEmail={showSecondaryEmail}
          showSecondaryPhone={showSecondaryPhone}
          showSecondaryPhoneType={showSecondaryPhoneType}
          phoneTypes={codeLists.phoneTypes.list}
          isEmailFixed={isEmailFixed}
          selectedCountryIcoCode={selectedCountryIcoCode}
        />
        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default Contacts
